import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import Home from "./components/pages/Home";
import DetailPage from "./components/pages/DetailPage";
import LocationPage from "./components/pages/LocationPage";
import FAQPage from "./components/pages/FAQPage";
import NewsDetailPage from "./components/pages/NewsDetailPage";
import { ForumPage } from "./components/pages/ForumPage";
import { OrganizationPage } from "./components/pages/OrganizationPage";
import { HouseHoldPage } from "./components/pages/HouseHoldPage";
import { IndividualPage } from "./components/pages/IndividualPage";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/цугларах-байршил" element={<LocationPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/pages/:slug" element={<DetailPage />} />
          <Route path="/:slug" element={<DetailPage />} />
          <Route path="/news/:slug" element={<NewsDetailPage />} />
          <Route path="/forum" element={<ForumPage />} />
          <Route path="/forum/organization" element={<OrganizationPage />} />
          <Route path="/forum/organization/:questionId" element={<OrganizationPage />} />
          <Route path="/forum/household" element={<HouseHoldPage />} />
          <Route path="/forum/individual" element={<IndividualPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
